<template>
    <div>
        <ais-instant-search
            :search-client="searchClient"
            :index-name="indexName"
        >
            <ais-configure
                :hits-per-page.camel="100"
            />
            <ais-search-box :autofocus="true" :class-names="{
                'ais-SearchBox-input': 'form-control'
            }">
                <div slot-scope="{ currentRefinement, isSearchStalled, refine }">
                    <input
                        type="search"
                        v-model="currentRefinement"
                        @input="refine($event.currentTarget.value)"
                        class="form-control text-remove"
                        @keypress="on()"
                        @keyup="offOverlay()"
                        @paste = "onPaste"
                        placeholder="Search project, company, contact, address, phone"
                        style="display: block"
                        id="algolia-search-box"
                        autocomplete="off"
                        contenteditable="true"
                    >
                    <span :hidden="!isSearchStalled"
                          class="hits card bg-white rounded-t-none w-1/4 italic">Loading...</span>
                </div>
            </ais-search-box>
            <ais-state-results id="searchBoxHide" style="z-index: 9999">
                <div slot-scope="{ state: { query }}">
                    <ais-hits v-if="query.length > 0" :transform-items="transformItems"
                              class="hits card bg-white " id="scrollToTop">

                        <ul slot-scope="{ items }"  class="hitsList mt-10">
                            <div class="row col-xs-12 m-0">
                                <!--Projects-->
                                <div v-if="showJob.less && !showJob.more" class="col-md-3 col-xs-12">
                                    <ul>
                                        <li class="" style="list-style-type: none;">
                                            <div class="col-md-3 d-flex">
                                                <span class="material-icons text-2xl"
                                                      style="color: rgb(1 177 175);">folder</span>
                                                <p class="ml-2" style="font-weight: bolder; font-size: 18px">PROJECTS</p>
                                            </div>
                                        </li>
                                        <li v-for="(item,index) in items.filter(function(x){
                                            return x.type === 'project' && x.users_can_see.includes(userId)
                                        })" :key="item.objectID" class="hover:underline pointer ml-3" style="list-style-type: none;" @click.prevent="link(item)">
                                            <div v-if="index < 3 && teamId == item.team_id">

                                                <div class="flex mt-3" v-show="canSee(item) && item.type === 'project'">
                                                    <div class="flex-initial">
                                                        <p>
                                                            <ais-highlight attribute="name" class="font-black text-break" style="font-weight: 600;" :hit="item"/>
                                                        </p>
                                                        <p class="italic text-xs tSettings text-gray-500">
                                                            <!--                                                        Type: {{hitType(item.type)}} <br>-->
                                                            {{
                                                            (item.type !== 'project' && item.type !== 'company') ? 'Project: ' : null
                                                            }}
                                                            <ais-highlight attribute="project_name" :hit="item"/>
                                                        </p>
                                                        <p  class="italic text-xs text-gray-500">
                                                            {{ item.sequential_team_id ? 'ID: ' : 'ID: ' }}
                                                            <ais-highlight attribute="sequential_team_id" :hit="item"/>
                                                            <br>
                                                            {{ item.address ? 'Address: ' : 'Address: ' }}
                                                            <ais-highlight attribute="address" :hit="item"/>
                                                            <br>
                                                            {{ item.phone ? 'Phone: ' : 'Phone: ' }}
                                                            <ais-highlight attribute="phone" :hit="item"/>
                                                            <br>
                                                            {{ item.email ? 'E-mail: ' : 'E-mail: ' }}
                                                            <ais-highlight attribute="email" class="text-break" :hit="item"/>
                                                            <br>
                                                            {{ item.account_manager ? 'Acct.Mngr: ' : 'Acct.Mngr: ' }}
                                                            <ais-highlight attribute="account_manager" :hit="item"/>
                                                            <br>
                                                            {{ item.sales_status ? 'Sales Status: ' : 'Sales Status: ' }}
                                                            <ais-highlight attribute="sales_status" :hit="item"/>
                                                            <br>
                                                            {{ item.base_bid ? 'Bid Amount: ' : 'Bid Amount: ' }}
                                                            <ais-highlight attribute="base_bid" :hit="item"/>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <div v-if="items.filter(function(x){return x.type === 'project' && x.users_can_see.includes(userId)}).length > 3" class="seeMore">
                                        <a class="text-center" @click="toggleShowMoreJobs(true);scrollTop()" style="font-size:12px; cursor: pointer;">See More Projects >> </a>
                                    </div>

                                </div>
                                <div v-if="showJob.more" style="">
                                    <div class="flex-initial">
                                        <a class="text-center ml-10" @click="toggleShowMoreJobs(false)" style="font-weight: bolder; cursor: pointer; color: rgb(1 177 175);">Back</a>
                                    </div>
                                    <div class="d-flex ml-12 mt-3">
                                                <span class="material-icons text-2xl"
                                                      style="color: rgb(1 177 175);">folder</span>
                                        <p class="ml-2" style="font-weight: bolder; font-size: 18px">PROJECTS</p>
                                    </div>
                                    <ul class="row m-0" style="list-style: none; list-style: none;margin: 0px;display: flex;flex-wrap: wrap;">
                                        <li v-for="item in items.filter(function(x){return x.type === 'project' && x.users_can_see.includes(userId) && x.team_id == teamId})" :key="item.objectID" class="col-lg-4 col-md-4 col-sm-12 p-3 hover:underline pointer" style="list-style-type: none;" @click.prevent="link(item)">
                                            <div class="">
                                                <div class="" v-show="canSee(item) && item.type === 'project'" style="min-width: 200px;">
                                                    <br/>
                                                    <div class="flex-initial">
                                                        <p>
                                                            <ais-highlight attribute="name" class="font-black" style="font-weight: 600;" :hit="item"/>
                                                        </p>
                                                        <p class="italic text-xs tSettings text-gray-500">
                                                            <!--                                                            Type: {{hitType(item.type)}} <br>-->
                                                            {{
                                                            (item.type !== 'project' && item.type !== 'company') ? 'Project: ' : null
                                                            }}
                                                            <ais-highlight attribute="project_name" :hit="item"/>
                                                        </p>
                                                        <p  class="italic text-xs text-gray-500">
                                                            {{ item.sequential_team_id ? 'ID: ' : 'ID: ' }}
                                                            <ais-highlight attribute="sequential_team_id" :hit="item"/>
                                                            <br>
                                                            {{ item.address ? 'Address: ' : 'Address: ' }}
                                                            <ais-highlight attribute="address" :hit="item"/>
                                                            <br>
                                                            {{ item.phone ? 'Phone: ' : 'Phone: ' }}
                                                            <ais-highlight attribute="phone" :hit="item"/>
                                                            <br>
                                                            {{ item.email ? 'E-mail: ' : 'E-mail: ' }}
                                                            <ais-highlight attribute="email" :hit="item"/>
                                                            <br>
                                                            {{ item.account_manager ? 'Acct.Mngr: ' : 'Acct.Mngr: ' }}
                                                            <ais-highlight attribute="account_manager" :hit="item"/>
                                                            <br>
                                                            {{ item.sales_status ? 'Sales Status: ' : 'Sales Status: ' }}
                                                            <ais-highlight attribute="sales_status" :hit="item"/>
                                                            <br>
                                                            {{ item.base_bid ? 'Bid Amount: ' : 'Bid Amount: ' }}
                                                            <ais-highlight attribute="base_bid" :hit="item"/>
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <!--Company-->
                                <div v-if="showCompany.less && !showCompany.more" class="col-md-3 col-xs-12">
                                    <ul>
                                        <li class="" style="list-style-type: none;">
                                            <div class="col-md-3 d-flex">
                                                    <span class="material-icons text-2xl"
                                                          style="color: rgb(1 177 175);">business</span>
                                                <p class="ml-2" style="font-weight: bolder;  font-size: 18px">COMPANIES</p>
                                            </div>
                                        </li>
                                        <li v-for="(item,index) in items.filter(function(x){return x.type === 'company'})" :key="item.objectID" class="hover:underline pointer ml-3" style="list-style-type: none;" @click.prevent="link(item)">
                                            <div v-if="index < 3 && teamId == item.team_id" >

                                                <div class="flex mt-3" v-show="canSee(item) && item.type === 'company'">
                                                    <div class="flex-initial">
                                                        <p>
                                                            <ais-highlight attribute="name" class="font-black text-break" style="font-weight: 600;" :hit="item"/>
                                                        </p>
                                                        <p class="italic text-xs tSettings text-gray-500">
                                                            <!--                                                        Type: {{ hitType(item.type) }} <br>-->
                                                            {{
                                                            (item.type !== 'project' && item.type !== 'company') ? 'Project: ' : null
                                                            }}
                                                            <ais-highlight attribute="project_name" :hit="item"/>
                                                        </p>
                                                        <p  class="italic text-xs text-gray-500">
                                                            {{ item.address ? 'Address: ' : 'Address: ' }}
                                                            <ais-highlight attribute="address" :hit="item"/>
                                                            <br>
                                                            {{ item.city ? `City: ` : `City: ` }}
                                                            <ais-highlight attribute="city" :hit="item"/>
                                                            <br>
                                                            {{ item.state ? `State: ` : `State: ` }}
                                                            <ais-highlight attribute="state" :hit="item"/>
                                                            <br>
                                                            {{ item.zip ? `Zip: ` : `Zip: ` }}
                                                            <ais-highlight attribute="zip" :hit="item"/>
                                                            <br>
                                                            {{ item.phone ? 'Phone: ' : 'Phone: ' }}
                                                            <ais-highlight attribute="phone" :hit="item"/>
                                                            <br>
                                                            {{ item.fax ? `Fax: ` : `Fax: ` }}
                                                            <ais-highlight attribute="fax" :hit="item"/>
                                                            <br>
                                                            {{ item.cell ? `Cellphone: ` : `Cellphone: ` }}
                                                            <ais-highlight attribute="cell" :hit="item"/>
                                                            <br/>
                                                            {{ item.email ? 'E-mail: ' : 'E-mail: ' }}
                                                            <ais-highlight attribute="email" class="text-break" :hit="item"/>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <div v-if="items.filter(function(x){return x.type === 'company'}).length > 3" class="seeMoreCompanies">
                                        <a class="text-center" @click="toggleShowMoreCompanies(true);scrollTop()" style="font-size:12px; cursor: pointer;">See More Companies>> </a>
                                    </div>

                                </div>
                                <div v-if="showCompany.more" class="" style="">
                                    <div class="flex-initial">
                                        <a class="text-center ml-10" @click="toggleShowMoreCompanies(false)" style="font-weight: bolder; cursor: pointer; color: rgb(1 177 175);">Back</a>
                                    </div>
                                    <div class="d-flex ml-12 mt-3">
                                                    <span class="material-icons text-2xl"
                                                          style="color: rgb(1 177 175);">business</span>
                                        <p class="ml-2" style="font-weight: bolder;  font-size: 18px">COMPANIES</p>
                                    </div>
                                    <ul class="row m-0" style="list-style: none; list-style: none;margin: 0px;display: flex;flex-wrap: wrap;">
                                        <li v-for="item in items.filter(function(x){return x.type === 'company' && x.team_id == teamId})" :key="item.objectID" class="hover:underline pointer col-lg-4 col-md-4 col-sm-12 p-3" style="list-style-type: none;" @click.prevent="link(item)">
                                            <div class="">
                                                <div class="" style="min-width: 200px;" v-show="canSee(item) && item.type === 'company'">
                                                    <div class="flex-initial">
                                                        <p>
                                                            <ais-highlight attribute="name" class="font-black text-break" style="font-weight: 600;" :hit="item"/>
                                                        </p>
                                                        <p class="italic text-xs tSettings text-gray-500">
                                                            <!--                                                            Type: {{ hitType(item.type) }} <br>-->
                                                            {{
                                                            (item.type !== 'project' && item.type !== 'company') ? 'Project: ' : null
                                                            }}
                                                            <ais-highlight attribute="project_name" :hit="item"/>
                                                        </p>
                                                        <p  class="italic text-xs text-gray-500">
                                                            {{ item.address ? 'Address: ' : 'Address: ' }}
                                                            <ais-highlight attribute="address" :hit="item"/>
                                                            <br>
                                                            {{ item.city ? `City: ` : `City: ` }}
                                                            <ais-highlight attribute="city" :hit="item"/>
                                                            <br>
                                                            {{ item.state ? `State: ` : `State: ` }}
                                                            <ais-highlight attribute="state" :hit="item"/>
                                                            <br>
                                                            {{ item.zip ? `Zip: ` : `Zip: ` }}
                                                            <ais-highlight attribute="zip" :hit="item"/>
                                                            <br>
                                                            {{ item.phone ? 'Phone: ' : 'Phone: ' }}
                                                            <ais-highlight attribute="phone" :hit="item"/>
                                                            <br>
                                                            {{ item.fax ? `Fax: ` : `Fax: ` }}
                                                            <ais-highlight attribute="fax" :hit="item"/>
                                                            <br>
                                                            {{ item.cell ? `Cellphone: ` : `Cellphone: ` }}
                                                            <ais-highlight attribute="cell" :hit="item"/>
                                                            <br/>
                                                            {{ item.email ? 'E-mail: ' : 'E-mail: ' }}
                                                            <ais-highlight attribute="email" class="text-break" :hit="item"/>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <!--Contact-->
                                <div v-if="showContact.less && !showContact.more" class="col-md-3 col-xs-12">
                                    <ul>
                                        <li class="" style="list-style-type: none; display: flex">
                                                <span class="material-icons text-2xl"
                                                      style="color: rgb(1 177 175);">person</span>
                                            <p class="ml-2" style="font-weight: bolder; font-size: 18px">CONTACTS</p>
                                        </li>
                                        <li v-for="(item,index) in items.filter(function(x){ return x.type === 'contact' && x.name !== null})" :key="item.objectID" class="hover:underline pointer ml-2" style="list-style-type: none;" @click.prevent="link(item)">
                                            <div v-if="index < 3 && teamId == item.team_id" >
                                                <div class="flex mt-3"  v-show="canSee(item) && item.type === 'contact' && item.name !== null">
                                                    <div class="flex-initial">
                                                        <p>
                                                            <ais-highlight attribute="name" class="font-black text-break" style="font-weight: 600;" :hit="item"/>
                                                        </p>
                                                        <p class="italic text-xs tSettings text-gray-500 text-break">
                                                            <!--                                                        Type: {{ hitType(item.type) }} <br>-->
                                                            <!--                                                        {{item }}-->
                                                            {{
                                                            (item.type !== 'project' && item.type !== 'company') ? 'Project: ' : null
                                                            }}
                                                            <ais-highlight attribute="project_name" :hit="item"/>
                                                        </p>
                                                        <p class="italic text-xs text-gray-500">
                                                            {{ item.phone ? 'Phone: ' : 'Phone: ' }}
                                                            <ais-highlight attribute="phone" :hit="item"/>
                                                            <br>
                                                            {{ item.fax ? `Fax: ` : `Fax: ` }}
                                                            <ais-highlight attribute="fax" :hit="item"/>
                                                            <br>
                                                            {{ item.cell ? `Cellphone: ` : `Cellphone: ` }}
                                                            <ais-highlight attribute="cell" :hit="item"/>
                                                            <br/>
                                                            {{ item.email ? 'E-mail: ' : 'E-mail: ' }}
                                                            <ais-highlight attribute="email" class="text-break" :hit="item"/>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <div v-if="items.filter(function(x){ return x.type === 'contact' && x.name !== null}).length > 3" class="seeMore">
                                        <a class="text-center" @click="toggleShowMoreContacts(true);scrollTop()" style="font-size:12px; cursor: pointer;">See More Contacts>> </a>
                                    </div>
                                </div>
                                <div v-if="showContact.more" class="" style="">
                                    <div class="flex-initial">
                                        <a class="text-center ml-10" @click="toggleShowMoreContacts(false)" style="font-weight: bolder; cursor: pointer; color: rgb(1 177 175);">Back</a>
                                    </div>
                                    <div class="d-flex ml-12 mt-3">
                                        <span class="material-icons text-2xl"
                                              style="color: rgb(1 177 175);">person</span>
                                        <p class="ml-2" style="font-weight: bolder; font-size: 18px">CONTACTS</p>
                                    </div>
                                    <ul class="row m-0" style="list-style: none; list-style: none;margin: 0px;display: flex;flex-wrap: wrap;">

                                        <li v-for="item in items.filter(function(x){ return x.type === 'contact' && x.name !== null && x.team_id == teamId})" :key="item.objectID" class=" col-lg-4 col-md-4 col-sm-12 p-3 hover:underline pointer" style="list-style-type: none;" @click.prevent="link(item)">

                                            <div class="">
                                                <div class="" style="min-width: 200px;" v-show="canSee(item) && item.type === 'contact'">
                                                    <div class="flex-initial">
                                                        <p>
                                                            <ais-highlight attribute="name" class="font-black text-break" style="font-weight: 600;" :hit="item"/>
                                                        </p>
                                                        <p class="italic text-xs tSettings text-gray-500">
                                                            <!--                                                            Type: {{ hitType(item.type) }} <br>-->
                                                            {{
                                                            (item.type !== 'project' && item.type !== 'company') ? 'Project: ' : null
                                                            }}
                                                            <ais-highlight attribute="project_name" :hit="item"/>
                                                        </p>
                                                        <p class="italic text-xs text-gray-500">
                                                            {{ item.phone ? 'Phone: ' : 'Phone: ' }}
                                                            <ais-highlight attribute="phone" :hit="item"/>
                                                            <br>
                                                            {{ item.fax ? `Fax: ` : `Fax: ` }}
                                                            <ais-highlight attribute="fax" :hit="item"/>
                                                            <br>
                                                            {{ item.cell ? `Cellphone: ` : `Cellphone: ` }}
                                                            <ais-highlight attribute="cell" :hit="item"/>
                                                            <br/>
                                                            {{ item.email ? 'E-mail: ' : 'E-mail: ' }}
                                                            <ais-highlight attribute="email" class="text-break" :hit="item"/>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <!--Resource-->
                                <div v-if="showResource.less && !showResource.more" class="col-md-3 col-xs-12">
                                    <ul>
                                        <li class="" style="list-style-type: none; display: flex">
                                                <span class="material-icons text-2xl"
                                                      style="color: rgb(1 177 175);">description</span>
                                            <p class="ml-2" style="font-weight: bolder;  font-size: 18px">RESOURCES</p>
                                        </li>
                                        <li v-for="(item,index) in items.filter(function(x){return x.type === 'resource'})" :key="item.objectID" class="hover:underline pointer" style="list-style-type: none;" @click.prevent="link(item)">
                                            <div v-if="index < 3 && teamId == item.team_id" >

                                                <div class="flex mt-3" v-show="canSee(item) && item.type === 'resource'">
                                                    <div class="flex-initial">
                                                        <p>
                                                            <ais-highlight attribute="name" class="font-black text-break" style="font-weight: 600;" :hit="item"/>
                                                        </p>
                                                        <p class="italic text-xs tSettings text-gray-500">
                                                            <!--                                                        Type: {{ hitType(item.type) }} <br>-->
                                                            {{
                                                            (item.type !== 'project' && item.type !== 'company') ? 'Project: ' : null
                                                            }}
                                                            <ais-highlight attribute="project_name" :hit="item"/>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <div v-if="items.filter(function(x){return x.type === 'resource'}).length > 3" class="seeMore">
                                        <a class="text-center" @click="toggleShowMoreResources(true);scrollTop()" style="font-size:12px; cursor: pointer;">See More Resource>> </a>
                                    </div>

                                </div>
                                <div v-if="showResource.more" class="" style="">
                                    <div class="flex-initial">
                                        <a class="text-center ml-10" @click="toggleShowMoreResources(false)" style="font-weight: bolder; cursor: pointer; color: rgb(1 177 175);">Back</a>
                                    </div>
                                    <div class="d-flex ml-12 mt-3">
                                        <span class="material-icons text-2xl"
                                              style="color: rgb(1 177 175);">description</span>
                                        <p class="ml-2" style="font-weight: bolder;  font-size: 18px">RESOURCES</p>
                                    </div>
                                    <ul class="row m-0" style="list-style: none; list-style: none;margin: 0px;display: flex;flex-wrap: wrap;">
                                        <li v-for="item in items.filter(function(x){return x.type === 'resource' && x.team_id == teamId})" :key="item.objectID" class="col-lg-4 col-md-4 col-sm-12 p-3 hover:underline pointer" style="list-style-type: none;" @click.prevent="link(item)">

                                            <div class="">
                                                <div class="" style="min-width: 250px;" v-show="canSee(item) && item.type === 'resource'">
                                                    <div class="flex-initial">
                                                        <p>
                                                            <ais-highlight attribute="name" class="font-black text-break" style="font-weight: 600;" :hit="item"/>
                                                        </p>
                                                        <p class="italic text-xs tSettings text-gray-500">
                                                            <!--                                                            Type: {{ hitType(item.type) }} <br>-->
                                                            {{
                                                            (item.type !== 'project' && item.type !== 'company') ? 'Project: ' : null
                                                            }}
                                                            <ais-highlight attribute="project_name" :hit="item"/>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </ul>
                    </ais-hits>
                </div>
            </ais-state-results>
            <div id="overlay" @click="off()" style="display: none">

            </div>
        </ais-instant-search>
    </div>
</template>

<style>
.hits {
    position: absolute;
    width: 65vw;
    max-height: 60vh;
    left: 30%;
    overflow-y: scroll;
    padding-bottom: 20px;
}

@media(max-width:600px){
    .hits{
        left: 0;
        width: auto;
    }

    #hamBurgerBtn{
        display: none;
    }

    #mobileView{
        display: block;
    }
}

@media(min-width:601px){

    #hamBurgerBtn{
        display: none;
    }

    #mobileView{
        display: none;
    }
}

.hitsList {
    list-style-type: none;
    padding: 0;
}
.seeMore {
    text-align: center;
    margin-bottom: 20px;
    margin-top: 10px;
}

/*.seeMoreCompanies {*/
/*    text-align: center;*/
/*    margin-bottom: 20px;*/
/*    width: 80%;*/
/*    margin-left: auto;*/
/*}*/
.seeMoreCompanies{
    margin-left: 30px;
    text-align: center;
    margin-bottom: 20px;
    margin-top: 8px;
}
#overlay {
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top:18px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: -99;
    cursor: pointer;
    margin-top: 56px;
}
</style>

<script>

export default {
    name: "search",
    props: ['appId', "apiKey", "indexName", "isPm", "userId","teamId"],
    data() {
        return {
            searchClient: algoliasearch(
                this.appId,
                this.apiKey,
            ),
            types: {
                'project': 'Job',
                'resource': 'Document',
                'company': 'Company',
                'contact': 'Contact',
            },
            typeOrder:["project", "company", "contact", "resource"],
            showJob: {
                less: true,
                more: false
            },
            showCompany : {
                less: true,
                more: false
            },
            showContact : {
                less: true,
                more: false
            },
            showResource : {
                less: true,
                more: false
            },
        }
    },

    methods: {
        toggleShowMoreJobs(val) {
            if(val){
                this.showJob.more = true
                this.showCompany.less = false
                this.showContact.less = false
                this.showResource.less = false

            }else{
                this.showJob.more = false
                this.showCompany.less = true
                this.showContact.less = true
                this.showResource.less = true
            }
        },
        toggleShowMoreCompanies(val) {
            if(val){
                this.showJob.less = false
                this.showCompany.more = true
                this.showContact.less = false
                this.showResource.less = false

            }else{
                this.showJob.less = true
                this.showCompany.more = false
                this.showContact.less = true
                this.showResource.less = true
            }
        },
        toggleShowMoreContacts(val) {
            if(val){
                this.showJob.less = false
                this.showCompany.less = false
                this.showContact.more = true
                this.showResource.less = false

            }else{
                this.showJob.less = true
                this.showCompany.less = true
                this.showContact.more = false
                this.showResource.less = true
            }
        },
        toggleShowMoreResources(val) {
            if(val){
                this.showJob.less = false
                this.showCompany.less = false
                this.showContact.less = false
                this.showResource.more = true

            }else{
                this.showJob.less = true
                this.showCompany.less = true
                this.showContact.less = true
                this.showResource.more = false
            }
        },
        hitType(type) {
            return this.types[type];
        },
        link(data) {
            switch (data.type) {
                case 'project':
                    if (this.isPm) {
                        window.location = route('project-management.project.edit', {projectManagement: data.id});
                    } else {
                        window.location = route('project.edit', {project: data.id}) + `?project=1`;
                    }
                    break;
                case 'resource':
                    window.open(route('resource-files.show', {resourceFile: data.token}), '_blank');
                    break;
                case 'company':
                    window.location = route('company.show', {company: data.id});
                    break;
                case 'contact':
                    if (data.company_id)
                        window.location = route('contact.edit', {company: data.company_id, contact: data.id});
                    else
                        window.location = route('project.edit', {project: data.project_id}) + `?project=1`;
                    break;

            }
        },
        iconType(type) {
            switch (type) {
                case 'project':
                    return 'folder';
                    break;
                case 'resource':
                    return 'description';
                    break;
                case 'company':
                    return 'business';
                    break;
                case 'contact':
                    return 'person';
                    break;
                default:
                    return 'folder';
            }
        },
        canSee(item) {
            if (item.type == "project") {
                if (item.users_can_see != null) {

                    if (item.users_can_see.includes(this.userId) && item.team_id == parseInt(this.teamId)) {
                        return true;
                    }
                }
                return false;
            } else if (item.type == "company" || item.type == "contact") {
                if(item.team_id == parseInt(this.teamId)) {
                    return true;
                }
                return false;
            }else{
                return true;
            }
        },
        transformItems (items){
            return items.sort((a, b) => this.typeOrder.indexOf(a.type) - this.typeOrder.indexOf(b.type));
        },
        on() {
            document.getElementById("overlay").style.display = "block";
            $('#searchBoxHide').show();
        },
        off() {
            document.getElementById("overlay").style.display = "none";
            $('.text-remove').val('');
            $('#searchBoxHide').hide();
            this.toggleShowMoreJobs(false);
            this.toggleShowMoreCompanies(false);
            this.toggleShowMoreContacts(false);
            this.toggleShowMoreResources(false);
        },
        offOverlay(){
            var searchValue = $('#algolia-search-box').val();
            if(searchValue == "" || searchValue == null || searchValue == undefined){
                document.getElementById("overlay").style.display = "none";
                this.toggleShowMoreJobs(false);
                this.toggleShowMoreCompanies(false);
                this.toggleShowMoreContacts(false);
                this.toggleShowMoreResources(false);
            }
        },
        scrollTop(){
            $("#scrollToTop").animate({ scrollTop: 0 }, 600);
            // document.getElementById("scrollToTop").scrollTop = 0; // For Safari
            // document.getElementById("scrollToTop").scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        onPaste(evt){
            document.getElementById("overlay").style.display = "block";
            $('#searchBoxHide').show();
        },
    }
}
</script>
